import { StateCreator } from 'zustand';
import { QuotationStore } from '../quotationStore.types';
import { Quotation } from '@/types/quotation';

export interface HistorySlice {
    past: Quotation[];
    future: Quotation[];
    undo: () => void;
    redo: () => void;
}

export const createHistorySlice: StateCreator<
    QuotationStore,
    [],
    [],
    HistorySlice
> = (set, get) => ({
    past: [],
    future: [],

    undo: () => {
        const { past, currentQuotation, quotations } = get();
        if (past.length === 0 || !currentQuotation) return;
        const previous = past[past.length - 1];
        const newPast = past.slice(0, past.length - 1);
        const newFuture = [currentQuotation, ...get().future];

        const updatedQuotations = quotations.map((q) =>
            q.metadata?.quoteId === previous.metadata?.quoteId ? previous : q
        );

        set({
            past: newPast,
            future: newFuture,
            currentQuotation: previous,
            quotations: updatedQuotations,
        });
    },

    redo: () => {
        const { future, currentQuotation, quotations } = get();
        if (future.length === 0 || !currentQuotation) return;
        const next = future[0];
        const newFuture = future.slice(1);
        const newPast = [...get().past, currentQuotation];

        const updatedQuotations = quotations.map((q) =>
            q.metadata?.quoteId === next.metadata?.quoteId ? next : q
        );

        set({
            past: newPast,
            future: newFuture,
            currentQuotation: next,
            quotations: updatedQuotations,
        });
    },
});
